import { useInfiniteQuery } from '@tanstack/react-query';
import { SaleData } from '@interfaces/api/responses/my-sale';
import useUser from '@hooks/user/use-user';
import { OrdersSalesQueryKeys } from '@enums/react-query-keys';
import { getSales } from '@services/my-orders-sales-service';

const useSalesQuery = (
  productIds?: number[],
  searchText?: string,
  fromDate?: string,
  toDate?: string,
  bookmarkProductId?: string,
  enabled?: boolean,
) => {
  const { user, isAuthenticated } = useUser();
  const userId = user?.id ?? '';

  const { isFetching, isLoading, data, fetchNextPage, hasNextPage, isFetchingNextPage, isError, isFetched } =
    useInfiniteQuery<SaleData>({
      queryKey: [OrdersSalesQueryKeys.SALES, userId, searchText, fromDate, toDate, productIds, bookmarkProductId],
      queryFn: ({ pageParam = 1 }) => {
        if (pageParam === 1) {
          return getSales(Number(pageParam), productIds, fromDate, toDate, bookmarkProductId);
        }
        return getSales(Number(pageParam), productIds, fromDate, toDate);
      },
      getNextPageParam: (lastPage, pages) => {
        const { hasMore } = lastPage;

        if (hasMore) {
          return pages.length + 1;
        }
        return undefined;
      },
      enabled: isAuthenticated && enabled,
    });

  return { isFetching, isLoading, data, fetchNextPage, hasNextPage, isFetchingNextPage, isError, isFetched };
};

export default useSalesQuery;
